import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfileOptions, setProfileOptions } from "../../slices/bp";
export const useProfileOptions = () => {
    const dispatch = useDispatch();
    const profileOptions = useSelector(getProfileOptions);
    const update = useCallback((value) => {
        dispatch(setProfileOptions(value));
    }, [dispatch]);
    return [profileOptions, update];
};
